import React from 'react';
import Accordion from 'components/Accordion';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import Culture from './Culture';
import ForecastDate from './ForecastDate';
import Period from './Period';
import './index.scss';

export default function MapControlPanel({ map, position, totalMaps }: {
  map: CultureIndexAreaMap,
  position: number,
  totalMaps: number,
}) {
  const showTitle = totalMaps > 1;

  return (
    <>
      {showTitle && (
        <div className="culture-index-control-panel-title">
          {`Mapa ${position}`}
        </div>
      )}
      <Accordion>
        <Culture map={map} />
        <ForecastDate map={map} />
        <Period map={map} />
      </Accordion>
    </>
  );
}
